import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

interface ApiResponse<T> {
  data?: T;
  error?: string;
  loading: boolean;
}

export const useApi = () => {
  const [loading, setLoading] = useState(false);

  const request = async <T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<ApiResponse<T>> => {
    setLoading(true);
    
    try {
      const response = await fetch(`${API_URL}${endpoint}`, {
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        ...options,
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          error: data.error || 'Error en la solicitud',
          loading: false,
        };
      }

      return {
        data,
        loading: false,
      };
    } catch (error) {
      return {
        error: 'Error de conexión',
        loading: false,
      };
    } finally {
      setLoading(false);
    }
  };

  const createRoom = async (playerName: string, isLocal = false, localPlayers: string[] = []) => {
    return request<{ roomId: string; roomCode: string; playerId: string; players: any[] }>('/api/rooms', {
      method: 'POST',
      body: JSON.stringify({ playerName, isLocal, localPlayers }),
    });
  };

  const joinRoom = async (roomCode: string, playerName: string) => {
    return request<{ roomId: string; playerId: string }>(`/api/rooms/${roomCode}/join`, {
      method: 'POST',
      body: JSON.stringify({ playerName }),
    });
  };

  const getRoom = async (roomId: string) => {
    return request<any>(`/api/rooms/${roomId}`);
  };

  const startGame = async (roomId: string) => {
    return request<any>(`/api/rooms/${roomId}/start`, {
      method: 'POST',
    });
  };

  const vote = async (roomId: string, voterId: string, targetId: string) => {
    return request<any>(`/api/rooms/${roomId}/vote`, {
      method: 'POST',
      body: JSON.stringify({ voterId, targetId }),
    });
  };

  return {
    loading,
    createRoom,
    joinRoom,
    getRoom,
    startGame,
    vote,
  };
};
